import { render } from "./SyncedTeleport.vue?vue&type=template&id=bf73a338"
import script from "./SyncedTeleport.vue?vue&type=script&lang=ts"
export * from "./SyncedTeleport.vue?vue&type=script&lang=ts"
script.render = render

export default script